import PreparedMessage from 'components/PreparedMessage/PreparedMessage'
import { getCRsIdsFromBranchList } from 'helpers/getCRsIdsFromBranchList'
import useShopStatistics from 'hooks/useShopStatistics'
import { CashRegistersIconNew, CashRegistersIconTablet, CustomersIconNew, CustomersIconTablet, DashboardCheckIconNew, DashboardCheckIconTablet, TotalIconNew, TotalIconTablet } from 'media/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import StatsCard from '../StatsCard'
import { StyledStatsList } from './styled'

const StatsList = ({ shopId, mainCurrency, branchList, formatedDate, dateIsToday }) => {
	const [t] = useTranslation()
	// CASH REGISTERS QUANTITY INFO
	const branch = branchList?.find(shop => +shop.id === +shopId)
	const allowedCashRegisters = branch?.cashRegisters
		?.filter(cashRegister => cashRegister.isAvailableInWebApp)
	const allowedCrsIds = allowedCashRegisters
		?.map(cashRegister => cashRegister.id)
	const cashRegistersCount = branch?.cashRegisters?.length
	const allowedCashRegistersCount = allowedCrsIds?.length

	// SHOP STATISTICS
	const { branchList: branchListWithStatistic, loading } = useShopStatistics({
		branchList, date: formatedDate,
		cashRegisterIds: dateIsToday ? allowedCrsIds : getCRsIdsFromBranchList(branchList),
		dateIsToday
	})
	const shopData = branchListWithStatistic
		.find(({ id }) => +id === +shopId)
	const {
		total = 0,
		customerCount = 0,
		totalPerBill = 0
	} = shopData?.statistics || {}

	return (
		<StyledStatsList>
			{
				loading ? <PreparedMessage type='loading' /> : (
					<>
						<StatsCard
							label={t('dashboard_section.total')}
							textColor={'#45DB5D'}
							Icon={TotalIconNew}
							IconTablet={TotalIconTablet}
							className='totalStat'
							currency={mainCurrency}
						>
							{total?.toFixed(2)}
						</StatsCard>
						<StatsCard
							label={t('dashboard_section.Ø_purchase_amount')}
							textColor='#FFCA00'
							Icon={DashboardCheckIconNew}
							IconTablet={DashboardCheckIconTablet}
							className='totalKStat'
						>
							{`${totalPerBill?.toFixed(2) || 0} ${mainCurrency}`}
						</StatsCard>
						<StatsCard
							label={t('dashboard_section.customers')}
							textColor='#4A90E2'
							Icon={CustomersIconNew}
							IconTablet={CustomersIconTablet}
							className='billCountStat'
						>
							{customerCount}
						</StatsCard>
						<StatsCard
							label={t('dashboard_section.active_cash_registers')}
							textColor='#B0B0B0'
							Icon={CashRegistersIconNew}
							IconTablet={CashRegistersIconTablet}
							className='cashRegistersStat'
						>
							<span className='stats_card__value_highlighted'>{allowedCashRegistersCount}</span>
												/{cashRegistersCount}
						</StatsCard>
					</>
				)
			}
		</StyledStatsList>
	)
}

export default StatsList
